import * as Bixby from '$/core';

export interface MsalState {
  authenticated: boolean;
  isLoading: boolean;
  error?: string;
}

export const MSAL_LOGIN_INPROGRESS = 'MSAL_LOGIN_INPROGRESS';
export const MSAL_LOGIN_SUCCESS = 'MSAL_LOGIN_SUCCESS';
export const MSAL_LOGIN_FAILURE = 'MSAL_LOGIN_FAILURE';
export const MSAL_LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

interface MsalLoginInProgress extends Bixby.Models.BixbyAction {
  type: typeof MSAL_LOGIN_INPROGRESS;
}

interface MsalLoginSuccess extends Bixby.Models.BixbyAction {
  type: typeof MSAL_LOGIN_SUCCESS;
}

interface MsalLoginFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError> {
  type: typeof MSAL_LOGIN_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface LogoutSuccess extends Bixby.Models.BixbyAction<void> {
  type: typeof MSAL_LOGOUT_SUCCESS;
}

export type MsalLoginActionTypes = MsalLoginInProgress | MsalLoginSuccess | MsalLoginFailure | LogoutSuccess;
